import './attendantItem.scss';
export class AttendantItemController {
    constructor() {
        this.checkAgentSlots = (ev) => {
            if (ev.detail.name !== undefined) {
                const index = ev.detail.name;
                const attendant = this.attendants[index - 1];
                attendant.editingAgentSlots = ev.detail.value;
            }
        };
        this.updateInputQueuesEdit = (ev) => {
            if (ev.detail.name !== undefined) {
                const index = ev.detail.name;
                const teams = ev.detail.data;
                const attendant = this.attendants[index - 1];
                attendant.editingTeams = teams.map(t => {
                    return { label: t };
                });
                this.editTeams({ $attendant: attendant });
            }
        };
    }
    shouldShowIcons(attendant) {
        return this.editingAttendantIdentity === attendant.identity;
    }
    onChanges() {
        this.teams = this.attendants.teams.map(t => ({ text: t }));
        this.email =
            this.attendants.email ||
                decodeURIComponent(this.attendants.identity.split('@')[0]);
        this.name = this.attendants.fullName || this.email.split('@')[0];
    }
    getQueueEdit(queue) {
        return queue.map(t => t.label);
    }
    $deleteModel(attendant) {
        this.onDelete({ $attendant: attendant });
    }
    $closeDropdownDelete() {
        this.editingAttendantIdentity = undefined;
        this.closeDropdownDelete();
    }
    $closeDropdownEdit(attendant) {
        this.editingAttendantIdentity = undefined;
        this.closeDropdownEdit({ $attendant: attendant });
    }
    getAttendantSlotsDisplay(attendant) {
        if (attendant.agentSlots === 0) {
            return '-';
        }
        return attendant.agentSlots || this.ownerAgentSlots || '-';
    }
    $onCheckAttendant(selected) {
        this.onCheckAttendant({ $selected: selected });
    }
    $attendantPermission(attendant) {
        this.attendantPermission({ $attendant: attendant });
    }
    $agentSlotsError(attendant) {
        return this.agentSlotsError({ $attendant: attendant });
    }
    $submitEditAttendant(attendant) {
        return this.onSave({ $attendant: attendant });
    }
    dropdownDirection(attendant) {
        const index = this.attendants.indexOf(attendant);
        if (index == -1) {
            return 'bottom';
        }
        // cases where dropdown needs to open to top instead of bottom:
        if ((this.attendants.length == 6 &&
            this.attendants.length - index == 1) ||
            (this.attendants.length == 7 &&
                this.attendants.length - index <= 4) ||
            (this.attendants.length >= 8 && this.attendants.length - index <= 5)) {
            return 'top';
        }
        return 'bottom';
    }
}
